import {CameraWarningResult} from 'src/services/api'

export function translateCameraWarnings(warnings: CameraWarningResult): string[] {
  const reasons = []
  if (warnings.invalidCodec) reasons.push('Codec inválido')
  if (warnings.invalidFps) reasons.push('FPS não suportado')
  if (warnings.invalidResolution) reasons.push('Resolução não suportada')
  if (warnings.unauthorized) reasons.push('Conexão não autorizada')
  if (warnings.notFound) reasons.push('Não foi possível encontrar a stream informada')
  return reasons
}
